import React, { useEffect, useState } from 'react';
import { Button, UncontrolledTooltip, Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import './plan.scss';
import { ListCheckSvg } from '../../shared/icon-svg/icon';
import { useLocation, useNavigate } from 'react-router';
import ReactGA from 'react-ga4';
import { useAppSelector } from '../../../../../app/config/store';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from './paymentForm';
import { Elements } from '@stripe/react-stripe-js';
import { format } from 'date-fns';
import { getSubscription } from '../../entities/case-forms/case-lawyer.reducer';

const stripe_key: any = process.env.STRIPE_PUBLISHABLE_KEY || '';
const stripePromise = loadStripe(String(stripe_key));

const PlanScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showCard, setShowCard] = useState<boolean>(false);
  const [viewCurrentPlan, setViewCurrentPlan] = useState<boolean>(false);
  const [selectedPlan, setSelectedPlan] = useState<any>('');
  const [currentPlan, setCurrentPlan] = useState<any>('');
  const [endDate, setEndDate] = useState<any>('');
  const [startDate, setStartDate] = useState<any>('');
  const { id } = useAppSelector(state => state.authentication?.account);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const amountPaid = currentPlan?.amountPaid ? currentPlan?.amountPaid / 100 : 0;
  const [planList, setPlanList] = useState<any>([]);
  const { entities, loading, entity } = useAppSelector(state => state.subscriptionPlan);
  const selectedPrice = parseFloat(selectedPlan?.price?.replace(/[^0-9.]/g, '') || '0');
  const difference = selectedPrice - amountPaid;
  const searchParams = new URLSearchParams(window.location.search);
  const submissionGuid = searchParams.get('submissionGuid');
  const fromHubspot = sessionStorage.getItem('fromHubspot');

  useEffect(() => {
    ReactGA.send({ hitType: 'PlanView', title: 'Plan', page: location.pathname });
  }, [location]);

  useEffect(() => {
    setPlanList(plans);
  }, [entity]);

  useEffect(() => {
    if (submissionGuid) {
      sessionStorage.setItem('fromHubspot', 'true');
      sessionStorage.setItem('hubspotSubmissionGuid', submissionGuid);
    }

    if (fromHubspot === 'true') {
      sessionStorage.removeItem('fromHubspot');
    }
  }, [submissionGuid]);

  useEffect(() => {
    const viewPlan = async () => {
      const plan: any = id && (await getSubscription(id));
      setCurrentPlan(plan);
      const endDate: any = plan?.endDate ? new Date(plan?.endDate) : null;
      const startDate: any = plan?.startDate ? new Date(plan?.startDate) : null;
      setEndDate(endDate ? format(endDate, 'dd MMM yyyy') : '');
      setStartDate(startDate ? format(startDate, 'dd MMM yyyy') : '');
    };
    viewPlan();
  }, [id, entity]);

  const plans = [
    {
      title: 'Free',
      name: 'Free',
      price: '$0',
      period: 'per case/ month',
      content: 'Help Resources and Option to Share Your Story',
      features: ['Help Resources', 'Option to Share Your Story'],
      upcomingfeature: [],
      buttonText: 'Choose Plan',
      bgColor: '#113B65',
      buttonClass: 'free',
      isPromoCode: false,
      planId: process.env.IS_DEV ? '2286' : '41091',
    },
    {
      title: '3-Month Access',
      name: '3-Month Access',
      price: '$49',
      period: 'per case/ 3 month',
      content: 'Downloadable Case Report and access to Legal Referrals ',
      features: [
        'Evidence Documenter',
        'Downloadable Case Report',
        'Help Resources',
        'Option to Share Your Story',
        'Support Referrals',
        'Legal Referrals',
      ],
      upcomingfeature: [],
      buttonText: 'Choose Plan',
      bgColor: 'light',
      buttonClass: 'sub',
      isPromoCode: true,
      planId: process.env.IS_DEV ? '2331' : '10311',
    },
    {
      title: '12-Month Access',
      name: 'Annual Access',
      price: '$99',
      period: 'per case/ year',
      content: 'Evidence Documenter, Case Report, Referrals and more',
      features: [
        'Evidence Documenter',
        'Downloadable Case Report',
        'Help Resources',
        'Legal Referrals',
        'Option to Share Your Story',
        'Support Referrals',
      ],
      upcomingfeature: ['Support Community', 'Auto-Transcribe', 'Screenshot Text Analyzer'],
      buttonText: 'Choose Plan',
      bgColor: 'light',
      buttonClass: 'sub',
      isPromoCode: true,
      planId: process.env.IS_DEV ? '2329' : '10321',
    },
  ];

  const createSubscription: any = async (plan: any) => {
    if (id) {
      setShowCard(true);
      setSelectedPlan(plan);
    } else {
      navigate('/');
    }
  };

  const handleCurrentPlan = (plan: any) => {
    setViewCurrentPlan(true);
    setSelectedPlan(plan);
  };

  const closeModal = () => {
    setShowCard(!showCard);
    setSelectedPlan('');
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const utmData = {
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_campaign: params.get('utm_campaign'),
      utm_term: params.get('utm_term'),
      utm_content: params.get('utm_content'),
    };

    Object.entries(utmData).forEach(([key, value]) => {
      if (value) {
        // sessionStorage.setItem(key, value);
        localStorage.setItem(key, value);
      }
    });
  }, []);

  return (
    <>
      <Elements stripe={stripePromise}>
        <PaymentForm showCard={showCard} toggle={() => closeModal()} selectedPlan={selectedPlan} />
      </Elements>
      <>
        <Modal isOpen={viewCurrentPlan} toggle={() => setViewCurrentPlan(false)} centered className="plan-details">
          <ModalHeader toggle={() => setViewCurrentPlan(false)}>
            <h5 className="mb-0 fw-bold">Plan Details</h5>
          </ModalHeader>
          <ModalBody>
            <div className="mb-5 title-section">
              <p className="mb-0">Plan</p>
              <h5 className="mb-0">{selectedPlan?.title}</h5>
            </div>

            <Row className="text-start mb-4">
              <Col md="4">
                <p className="mb-1 fw-semibold">Plan Price</p>
                <h6>
                  <span className="fw-bold"> {difference > 0 ? `$${amountPaid?.toFixed(2)}` : selectedPlan?.price}</span>{' '}
                  {difference > 0 && <span className="text-decoration-line-through text-muted ms-1 small">{selectedPlan?.price}</span>}
                </h6>
              </Col>
              <Col md="4">
                <p className="mb-1 fw-semibold">Start Date</p>
                <h6 className="fw-bold">{startDate ? startDate : ''}</h6>
              </Col>
              <Col md="4">
                <p className="mb-1 fw-semibold">Plan Validity</p>
                <h6 className="fw-bold">{endDate ? endDate : ''}</h6>
              </Col>
              {difference > 0 && (
                <Col className="mt-2">
                  <p className="mb-1 fw-semibold">Discount</p>
                  <h6>
                    <span className="fw-bold">
                      {(
                        ((parseFloat(selectedPlan?.price?.replace(/[^0-9.]/g, '') || '0') -
                          (currentPlan?.amountPaid ? currentPlan.amountPaid / 100 : 0)) /
                          parseFloat(selectedPlan?.price?.replace(/[^0-9.]/g, '') || '1')) *
                        100
                      ).toFixed(2)}
                      %
                    </span>
                  </h6>
                </Col>
              )}
            </Row>
            {/* <Row className="text-start mb-4">
              <Col md='4'>
                <p className="mb-1 fw-semibold">Plan Price</p>
                <h6>
                  <span className="fw-bold">{selectedPlan?.price}</span>{' '}
                </h6>
              </Col>

            </Row> */}
            {/* <Row className="text-center mb-4">
              <Col>
                <p className="text-muted mb-1 fw-semibold">Discount</p>
                <h6>
                  <span className="fw-bold">{(
          parseFloat(selectedPlan?.price?.replace(/[^0-9.]/g, "") || "0") -
          (currentPlan?.amountPaid ? currentPlan.amountPaid / 100 : 0)
        ).toFixed(2)}</span>{' '}
                </h6>
              </Col>   
                      
            </Row> */}
          </ModalBody>
        </Modal>
      </>
      <div
        className={`' main-content flex-grow-1 d-flex flex-column gap-3 justify-content-between px-4 pb-4 ${!isAuthenticated ? 'pt-5 public-plan' : ''}  `}
      >
        <div className="custom-container flex-grow-1">
          <h1 className="page-title">Choose your plan</h1>
          <p className="text-center text-lg-start">Access case support and resources</p>
          <Row className="justify-content-center mt-5">
            {planList?.map((plan: any, index: any) => (
              <Col
                sm={12}
                md={12}
                lg={4}
                key={index}
                className={`mb-4 planview-card ${plan.title === 'Free' ? 'ps-md-0 pe-3' : 'px-md-0'}`}
              >
                <Card className={`plan-card ${plan.title === 'Free' ? 'dark-bgcolor' : 'light-bgcolor'}`}>
                  <CardBody>
                    <div className="plan-data">
                      {(currentPlan?.name == plan?.name || currentPlan?.stripePriceId == plan?.planId) && (
                        <div className="current-tag d-flex gap-2" onClick={() => handleCurrentPlan(plan)}>
                          {' '}
                          Your current plan{' '}
                          <span id="plantooltip">
                            <img src="content/images/cases/Vector.svg" />
                          </span>
                          <UncontrolledTooltip target="plantooltip">View details</UncontrolledTooltip>
                        </div>
                      )}
                      <h4> {plan.title}</h4>
                      <p className={`${plan?.buttonClass}`}>{plan?.content?.replace(/,\s*/g, ', ')}</p>
                      <div className="d-flex gap-2 align-items-center mt-3">
                        <h2 className="mb-0">{plan.price}</h2>
                        <p className={`${plan.buttonClass}`}>{plan.period}</p>{' '}
                      </div>
                      <div className="text-center">
                        <Button className={` w-100 plan-data ${plan.buttonClass} `} onClick={() => createSubscription(plan)}>
                          {plan.buttonText}
                        </Button>
                        <div>
                          <ul className={`${plan.buttonClass} list-unstyled mt-3 `}>
                            {plan.features.map((feature: any, idx: any) => (
                              <li key={idx}>
                                {' '}
                                <span className={`${plan.title === 'Free' ? 'active' : 'default'}`}>
                                  <ListCheckSvg />
                                </span>{' '}
                                {feature}
                              </li>
                            ))}
                          </ul>
                        </div>
                        {plan.price === '$99' && (
                          <div className={`plan-badge ${plan?.title === 'Free' ? 'free' : 'paid'}`}>Coming Soon</div>
                        )}
                        <div>
                          <ul className={`${plan.buttonClass} list-unstyled mt-3 `}>
                            {plan?.upcomingfeature?.map((feature: any, idx: any) => (
                              <li key={idx}>
                                {' '}
                                <span className={`${plan.title === 'Free' ? 'active' : 'default'}`}>
                                  <ListCheckSvg />
                                </span>{' '}
                                {feature}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
        <div className="footer-sec">
          <span>
            {isAuthenticated && (
              <>
                <b className="faq" onClick={() => navigate('/case-faqs')}>
                  FAQ
                </b>{' '}
                |
              </>
            )}{' '}
            Disclaimer:
          </span>{' '}
          We are not a legal service provider. We connect you to referrals and provide reports and initial assessments based on best
          practices. This does not constitute legal advice. Always consult with legal counsel regarding specifics.
        </div>
      </div>
    </>
  );
};

export default PlanScreen;
